import type { QueryClient } from '@tanstack/react-query';

// Prefetch common queries to reduce perceived latency
export const prefetchCommonQueries = async (queryClient: QueryClient, locale: string) => {
    // Prefetch navigation data, categories, etc.
    const commonQueries = [
        {
            key: ['navigation', locale],
            fn: () => fetch(`/api/navigation?locale=${locale}`).then((r) => r.json()),
        },
        {
            key: ['categories', locale],
            fn: () => fetch(`/api/categories?locale=${locale}`).then((r) => r.json()),
        },
    ];

    // Execute all prefetches in parallel
    await Promise.all(
        commonQueries.map(({ key, fn }) =>
            queryClient.prefetchQuery({
                queryKey: key,
                queryFn: fn,
                staleTime: 10 * 60 * 1000, // 10 minutes
            })
        )
    );
};

// Prefetch on link hover for instant navigation
export const prefetchOnHover = (queryClient: QueryClient, href: string) => {
    // Extract page type and slug from href
    const match = href.match(/\/(shop|shows|comedians)\/([^/]+)/);
    if (!match) return;

    const [, type, slug] = match;

    queryClient.prefetchQuery({
        queryKey: [type, slug],
        queryFn: () => fetch(`/api/prefetch/${type}/${slug}`).then((r) => r.json()),
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};
